import { Component, Input, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { AttributeValue, EditedAttributeValues } from '../../../../../models/section-definition.model';
import { AttributeValidationError } from '../attribute-number-edit-row/attribute-number-edit-row.component';

export function getDateValidationError(
  attr: AttributeValue,
  value: string | null,
): AttributeValidationError | null {
  return !value && attr.isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
}

export function isSameDate(a: string | null | undefined, b: string | null | undefined): boolean {
  return (a ? new Date(a).getTime() : null) === (b ? new Date(b).getTime() : null);
}

@Component({
  selector: 'lib-attribute-date-edit-row',
  standalone: false,
  templateUrl: './attribute-date-edit-row.component.html',
  styleUrls: ['./attribute-date-edit-row.component.scss'],
})
export class AttributeDateEditRowComponent implements OnInit {
  @Input() attributeValue!: AttributeValue;
  @Input() editedValues: EditedAttributeValues = {};
  includeTime: boolean = false;
  value: string = '';
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    const id = this.attributeValue.attributeDefinitionId;
    this.includeTime = this.attributeValue.is24HourFormat != null;
    const date = ((id in this.editedValues ? this.editedValues[id] : this.attributeValue.dateValue) as string | null | undefined) ?? null;
    this.value = date ? formatDate(date, this.includeTime ? "yyyy-MM-dd'T'HH:mm" : 'yyyy-MM-dd', 'en-US') : '';
    this.validate(date);
  }

  onValueChange(value: string) {
    const newValue = value ? (this.includeTime ? `${value}:00` : `${value}T00:00:00`) : null;
    this.editedValues[this.attributeValue.attributeDefinitionId] = newValue;
    this.validate(newValue);
  }

  private validate(value: string | null) {
    this.error = value !== null && isSameDate(value, this.attributeValue.dateValue)
      ? null
      : getDateValidationError(this.attributeValue, value);
  }
}
